import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import reducers from './reducers/rootReducers';

const userInfoFromStorage = localStorage.getItem('shopkpr_userInfo')
  ? JSON.parse(localStorage.getItem('shopkpr_userInfo'))
  : null;
const cartItemsFromStorage = localStorage.getItem('shopkpr_cartItems')
  ? JSON.parse(localStorage.getItem('shopkpr_cartItems'))
  : [];
const shippingAddressFromStorage = localStorage.getItem(
  'shopkpr_shippingAddress'
)
  ? JSON.parse(localStorage.getItem('shopkpr_shippingAddress'))
  : {};
const paymentMethodFromStorage = localStorage.getItem('shopkpr_paymentMethod')
  ? JSON.parse(localStorage.getItem('shopkpr_paymentMethod'))
  : '';

const middleware = [thunk];
const initial = {
  userLogin: { user: userInfoFromStorage },
  cart: {
    cartItems: cartItemsFromStorage,
    shippingAddress: shippingAddressFromStorage,
    paymentMethod: paymentMethodFromStorage,
  },
};

export const store = createStore(
  reducers,
  initial,
  composeWithDevTools(applyMiddleware(...middleware))
);
